// extracted by mini-css-extract-plugin
module.exports = {"grid_item_textbox":"_1OS48"};